import React from 'react';
import ReactDOM from 'react-dom/client';
// import reportWebVitals from './reportWebVitals';
import App from './App';
import './i18n'
import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.Suspense fallback={<div>Loading...</div>}>
        <App />
    </React.Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();